import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import gsap from 'gsap';

import ImageSlider from '../components/ImageSlider';
import Footer from '../components/Footer';

import CheckIcon from '../assets/img/check-grey-icon.png';
import { ReactComponent as ArrowBack } from '../assets/arrowToRightWithTailCircle.svg';
import { ReactComponent as AreaIcon } from '../assets/single-room/area.svg';
import { ReactComponent as BedIcon } from '../assets/single-room/bed.svg';
import { ReactComponent as GuestsIcon } from '../assets/single-room/guests.svg';
import { ReactComponent as WifiIcon } from '../assets/single-room/wifi.svg';

import '../static/css/singleRoomPage.css';

const SingleRoomPage = () => {
    const { t, i18n } = useTranslation();

    let roomId = useParams();
    const [singleRoom, setSingleRoom] = useState([]);

    useEffect(() => {
        axios.get(`/api/rooms/${roomId['id']}`).then((response) => {
            setSingleRoom(response.data);
        });
    });

  return (
    <div className='d-flex flex-column align-items-center'>
        <div className='bg-color-dark col-12' style={{'height': '15vh'}}></div>
        <div className='col-md-11 col-xl-8 d-flex flex-column align-items-center my-5 pb-5'>
            <div className='col-11 col-md-12 my-3'><a href='/rooms/'><ArrowBack /></a></div>

            <div className='col-12 mt-4 mb-5' style={{'height': '0.5px', 'background-color': '#2f2f2f'}}></div>

            <div className='d-flex flex-md-row flex-column align-items-md-stretch align-items-center'>
                <div className='col-11 col-md-7'>
                    <div className='overflow-hidden' style={{width: "95%"}}>
                        <img src={singleRoom.room_main_image} alt='room' className='w-100'/>
                    </div>
                </div>

                <div className='col-11 col-md-5 d-flex flex-column justify-content-between row-gap-4 mt-4 mt-md-0'>
                    <div className=''>
                        <p className='text-black fs-2 font-gilroy-bold m-0 lh-1 mb-2'>{i18n.language === 'en' ? singleRoom.translations?.en?.name : singleRoom.translations?.uk?.name}</p>
                        <p className='text-black fs-6 font-gilroy-regular'>{i18n.language === 'en' ? singleRoom.translations?.en?.description : singleRoom.translations?.uk?.description}</p>
                    </div>

                    <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div>
                            <p className='fs-4 font-gilroy-bold h-0 m-0'>{singleRoom.price} {i18n.language === 'en' ? 'UAH/Night' : 'Грн/Ніч'}</p>
                            <p className='mb-0 fst-italic text-dark-skin'>{i18n.language === 'en' ? singleRoom.translations?.en?.breakfast_included : singleRoom.translations?.uk?.breakfast_included}</p>
                        </div>
                        <a href='https://www.booking.com/hotel/ua/oaza-iasinia.cs.html#room_110467301' target="_blank" className='col-5 text-white text-center fs-5 bg-color-light-skin border border-color-skin book-button-shadow py-2 my-1 buton-hover-skin font-gilroy-bold'>{t("book_room_button")}</a>
                    </div>
                </div>
            </div>

            <div className='col-12 d-flex flex-row justify-content-between align-items-center p-0 mb-4 mt-4'>
                <div className='align-self-stretch my-4' style={{'width': '0.5px'}} id='box-seperation-line'></div>

                <div className='col-2 d-flex flex-column align-items-center my-4'>
                    <GuestsIcon className="room-amenity-icon room-amenity-icon-guest" />
                    <p className=' text-color-dark fs-6 text-center font-gilroy-light my-1 room-amenity-text'>{i18n.language === 'en' ? singleRoom.translations?.en?.room_guest_number : singleRoom.translations?.uk?.room_guest_number}</p>
                </div>

                <div className='align-self-stretch my-4' style={{'width': '0.5px'}} id='box-seperation-line'></div>

                <div className='col-2 d-flex flex-column align-items-center my-4'>
                    <AreaIcon className="room-amenity-icon room-amenity-icon-area" />
                    <p className=' text-color-dark fs-6 text-center font-gilroy-light my-1 room-amenity-text'>{singleRoom.room_size} M²</p>
                </div>

                <div className='align-self-stretch my-4' style={{'width': '0.5px'}} id='box-seperation-line'></div>

                <div className='col-2 d-flex flex-column align-items-center my-4'>
                    <BedIcon className="room-amenity-icon mb-0" />
                    <p className=' text-color-dark fs-6 text-center font-gilroy-light my-1 room-amenity-text'>{i18n.language === 'en' ? singleRoom.translations?.en?.bed_type : singleRoom.translations?.uk?.bed_type}</p>
                </div>

                <div className='align-self-stretch my-4' style={{'width': '0.5px'}} id='box-seperation-line'></div>

                <div className='col-2 d-flex flex-column align-items-center my-4'>
                    <WifiIcon className="room-amenity-icon" />
                    <p className=' text-color-dark fs-6 text-center font-gilroy-light my-1 room-amenity-text'>WIFI</p>
                </div>

                <div className='align-self-stretch my-4' style={{'width': '0.5px'}} id='box-seperation-line'></div>
            </div>
            
            <div className='d-flex flex-md-row flex-column-reverse align-items-md-stretch align-items-center'>
                <div className='col-11 col-md-6 pt-4 px-3'>
                    <p className='fs-2 text-center'>{t('single_room_equipment_title')}</p>

                    <div className='d-flex flex-row flex-wrap justify-content-between'>
                        {singleRoom?.room_equipment?.map((equipment, key) => (
                            <div key={key} className='col-6 pe-1 d-flex flex-row'>
                                <div className='col-1'>
                                    <img src={CheckIcon} className='img-fluid' />
                                </div>
                                <p className='text-dark-color fs-6 font-mont-light ms-2'>{i18n.language === 'en' ? equipment?.translations?.en?.name : equipment?.translations?.uk?.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                 <div className='col-10 col-md-6'>
                    <div className='w-100 overflow-hidden'>
                        <ImageSlider images={singleRoom?.images} />
                    </div>
                </div>
            </div>

            <div className='col-12 my-5' style={{'height': '0.5px', 'background-color': '#2f2f2f'}}></div>
        </div>

        <Footer />
    </div>
  )
}

export default SingleRoomPage